<div class="host-edit-rate">
  <div class="er-container">
    <div class="rate-item" *ngIf="pageType === 'rate'">
      <span class="item-label">{{ "edit_rate.control.label.score" | translate }}</span>
      <div class="item-control">
        <nz-rate [(ngModel)]="score"></nz-rate>
      </div>
    </div>
    <div class="rate-item">
      <span class="item-label">{{ "edit_rate.control.label.content" | translate }} </span>
      <div class="item-control">
        <textarea
          nz-input 
          [placeholder]="(pageType === 'rate' ? 'edit_rate.control.placeholder.rate' : 'edit_rate.control.placeholder.reply') | translate"
          [(ngModel)]="content"></textarea>
        <div class="quick-tpl">
          <host-rate-tpl-picker
            (onSelect)="onSelectQuickRate($event)"></host-rate-tpl-picker>
        </div>
      </div>
    </div>
  </div>
  <div class="er-footer">
    <button nz-button (click)="onCancel()">{{ "word.cancel" | translate }}</button>
    <button nz-button nzType="primary" (click)="onSave()">{{ "word.save" | translate }}</button>
  </div>
</div>
